// ----------------------------------------------------------------------
// <copyright file="Izenda.LabelPosition.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Font Format component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var DropDown = require('./Izenda.DropDown');
  var constants = require('logic/data/Izenda.UIConstants');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const { clone, values } = require('lodash/fp');

  var LabelPosition = React.createClass({
    propTypes: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func.isRequired,
      disabled: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        value: {
          labelPosition: constants.LABEL_POSITION.right
        },
        blankOption: false,
        disabled: false
      };
    },

    handleChangePosition: function(e) {
      var props = this.props;
      var LabelPosition = clone(props.value);

      LabelPosition.labelPosition = e.value;
      props.onChange && props.onChange({ value: LabelPosition }, { keyChange: 'labelPosition' });
    },

    render: function() {
      var props = this.props;
      var disabled = props.disabled;
      var LabelPosition = this.props.value || {};
      var listLabelPosition = values(constants.LABEL_POSITION);

      let labelPosition=(LabelPosition.labelPosition!==null) ? LabelPosition.labelPosition : constants.LABEL_POSITION.right;

      return (
        <GridLayout>
          <GridLayout.FullRow>
            <GridLayout.Col cols={6} className='u_noPaddingRight'>
              <DropDown
                className='font-family'
                valueField=''
                labelField=''
                options={listLabelPosition}
                value={labelPosition}
                disabled={disabled}
                onChange={this.handleChangePosition}
                blankOption={props.blankOption}
              />
            </GridLayout.Col>
          </GridLayout.FullRow>
        </GridLayout>
      );
    }
  });

  module.exports = observer(LabelPosition);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.LabelPosition.jsx